export const environment = {
  production: true,
  API_ENDPOINT: 'https://api.ecosystm360.com/api/',
  BLOG_URL: 'https://blog.ecosystm360.com/',
  EVENTS_URL: 'https://blog.ecosystm360.com/events/',
  ECOSYSTM_TV_URL: 'https://blog.ecosystm360.com/ecosystm-tv/',
  MEDIA: 'https://blog.ecosystm360.com/media/',
  FAQ: 'https://blog.ecosystm360.com/faq/',
  KB: 'https://blog.ecosystm360.com/knowledge_base/',
  TOKBOX_KEY: '46189332',
  WP_AUTO_LOGIN_URL: 'https://blog.ecosystm360.com/auto-login',
  GOOGLE_MAP_KEY:'AIzaSyBqHX8_ArPTor3c2p3ffjOD_Ixw9sPtS50',
  STRIPE_PUBLIC_KEY:'pk_live_4VkRa3voyxEqqsynfwWFn5f4',
  GOOGLE_SITE_KEY:'6LdUtHUUAAAAAISigiyJrfMnsEDuHWa-RHM_dqN6',
  RAYGUN_API_KEY: '0IIusNRTVolH9yhadPaOQ',
  RAYGUN_API_VERSION: '1.0.0',
  RAYGUN_ENABLE_CRASH_REPORT: true,
  PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.perfomatix.ecosystmapp',
  APPLE_STORE_URL: 'https://itunes.apple.com/us/app/ecosystm-tech-research/id1436174787?ls=1&mt=8',
  ENABLE_APP_STORE_ICONS: true,
  ENV_NAME: 'Prod',
  VERSION: require('../../package.json').version,
  SHOW_BUILD_NO: false,
  LINKEDIN_CLIENT_ID: '81vxlx3pvzmhmj',
  LINKEDIN_URL:'https://www.linkedin.com/oauth/v2/authorization?response_type=code&state=aRandomString',
  LINKEDIN_SCOPE: 'scope=r_liteprofile r_emailaddress w_member_social',
  ONESIGNAL_APP_ID: '392b91bc-f8c4-46a7-9f60-e890397aed46',
  SOCIAL_SHARE_URL: 'https://socialshare.ecosystm360.com/socialShare-prod.php',
  MIXPANEL_KEY: '86cdb27b363567d69f3d5de9ecd378c3',
  AWS_PRE_SINGED_URL: `https://kvg2uh7p36.execute-api.ap-southeast-1.amazonaws.com/PROD/{proxy+}?name=`,
  AWS_EDITOR_IMAGE_URL: `https://es-s3-presigned-production.s3-ap-southeast-1.amazonaws.com/`,
  HUB_SPOT_PORTAL_ID: "4015851",
  HUB_SPOT_PORTAL_FORM_ID: "a4848604-3a17-4677-8bfd-b77900097996",
  SERVER_URL: 'https://socket-prod.ecosystm360.com/',

  IBM_IDP_URL: 'https://login.w3.ibm.com/saml/sps/saml20ip/saml20/login',
  SSO_RELAY_URL: 'https://www.ecosystm360.com/#/sso',
  SSO_SIGNUP_RELAY_URL: 'https://www.ecosystm360.com/#/sso-signup',

  PROJECT_PAYMENT_SUCCESS:'https://api.ecosystm360.com/api/stripe-checkouts/payment-success',
  PROJECT_PAYMENT_FAILURE:'https://api.ecosystm360.com/api/stripe-checkouts/payment-failure'

};




// WEBPACK FOOTER //
// ./src/environments/environment.ts